import { render, staticRenderFns } from "./package_list_row.vue.js?vue&type=template&id=64b8ee12!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./package_list_row.vue?vue&type=template&id=64b8ee12"
import script from "./package_list_row.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./package_list_row.vue?vue&type=script&lang=js"
export * from "./package_list_row.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./package_list_row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports